// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"368":"properties","443":"about","942":"not-found"}[chunkId] + "." + {"368":"f3833852","443":"58e9ed9b","942":"4c843651"}[chunkId] + ".css";
};